import { Button } from "../../../components/Button";
import { TermsCheckbox } from "../../../components/form/TermsCheckbox";
import { StandardField } from "./StandardField";
import clsx from "clsx";

export const ContactForm = ({
  data,
  formData,
  changeData,
  errors,
  consent,
  changeConsent,
  handleSubmit,
  sending,
  className,
}) => {
  return (
    <section className={clsx("contact_form-background", className)}>
      <section className="contact_form-main">
        <h2 className="contact_form-header">{data.header}</h2>
        <p className="contact_form-label">{data.label}</p>
        <section>
          <form onSubmit={handleSubmit}>
            <StandardField
              fields={data.fields}
              formData={formData}
              changeData={changeData}
              errors={errors}
            />
            <section id="consent" />
            <TermsCheckbox
              text={data.form.consent}
              checked={consent}
              onChange={changeConsent}
              error={errors.consent}
            />
            <section>
              <Button demystIcon variant="secondary" disabled={sending}>
                {data.form.button_text}
              </Button>
            </section>
          </form>
        </section>
      </section>
    </section>
  );
};
